import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { HttpModule, Http } from '@angular/http';
import { DndModule } from 'ng2-dnd';

// ng-bootstrap modules
import {
  ModalModule,
  AlertModule,
  PaginationModule,
  DatepickerModule,
  TimepickerModule
} from 'ng2-bootstrap';
import { TranslateModule, TranslatePipe, TranslateStaticLoader, TranslateLoader } from 'ng2-translate/ng2-translate';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// core
import { CoreModule } from './core/core.module';

// Shared
import {
  // FormMediaComponent,
  HeaderComponent,
  MenuComponent,
  TableComponent,
  ModalComponent,
  // VideoDirective,
  DateFormatPipe,
  TimeFormatPipe,
  DateTimeFormatPipe,
  ISOStringFormatPipe,
  UnitFilterPipe,
  ClusterFilterPipe,
  HttpClientService,
  UserService,
  LoginService
} from './shared/';

import { ChartsModule } from 'ng2-charts';

import { SharedModule } from './shared/shared.module';

import { LoginComponent } from './login/login.component';

//services
import { TableService } from './shared/table/table.service';
import { UploadFileService } from './shared/form-media/upload-file.service';

//guards
import { UnsavedChangesGuard } from './shared/unsaved-guard/unsaved-changes.guard';
import { AuthGuard } from './core/guards/auth.guard';

// TODO: Change to news.module
import { NewsComponent } from './noticias/news.component';
import { NewsListComponent } from './noticias/news-list/news-list.component';
import { NewsFormComponent } from './noticias/news-form/news-form.component';
import { NewsResolver } from './noticias/shared/news.resolver';
import { NewsService } from './noticias/shared/news.service';

import { LoginImageComponent } from './loginImage/loginimage.component';

import { EmployeesComponent } from './employees/employees.component';
import { EmployeesListComponent } from './employees/employees-list/employees-list.component';
import { EmployeesFormComponent } from './employees/employees-form/employees-form.component';
import { ForumComponent } from './forum/forum.component';
import { ForumService } from './forum/forum.service';

export function createTranslateLoader(http: Http) {
  return new TranslateStaticLoader(http, './assets/i18n', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    // CKEditorComponent,
    HeaderComponent,
    MenuComponent,
    TableComponent,
    // TODO: Move to news.module
    NewsComponent,
    NewsListComponent,
    NewsFormComponent,
    ModalComponent,
    DateTimeFormatPipe,
    UnitFilterPipe,
    ClusterFilterPipe,
    LoginComponent,
    LoginImageComponent,
    EmployeesComponent,
    EmployeesListComponent,
    EmployeesFormComponent,
    ForumComponent,
  ],
  imports: [
    AngularMultiSelectModule,
    BrowserModule,
    ChartsModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    DndModule.forRoot(),
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    DatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [Http]
  })
  ],
  exports: [
    // CKEditorComponent
    TableComponent,
    DndModule,
    // DateFormatPipe
  ],
  providers: [
    TableService,
    UploadFileService,
    UnsavedChangesGuard,
    // TODO: Change to news.module
    NewsResolver,
    NewsService,
    AuthGuard,
    HttpClientService,
    UserService,
    LoginService,
    ForumService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts